import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TransactionsPageRoutingModule } from './transactions-routing.module';

import { TransactionsPage } from './transactions.page';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { HighlightSearchPipe } from 'src/app/shared/pipes/highlight-search.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Ng2SearchPipeModule,
    TransactionsPageRoutingModule
  ],
  declarations: [TransactionsPage, HighlightSearchPipe]
})
export class TransactionsPageModule {}
